import React, { useState, useEffect } from 'react';
import FilledInput from '@material-ui/core/FilledInput';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { setCookie, clearCookie, getUserDetails } from '../../functions/Auth';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start ChangeAdminPassword component code ....
const ChangeAdminPassword = () => {
    let history = useHistory();
    const [spacing, setSpacing] = React.useState(2);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errPassword, setErrNewPassword] = React.useState(null);
    const [errCnfPassword, setErrCnfPassword] = React.useState(null);
    const [errCode, setErrCode] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    const [passwordValues, setPasswordValues] = React.useState({
        pwd: "",
        cnfNewPwd: "",
        confirmationcode: ""
    });
    const [validPwd, setValidPwd] = useState(false);
    const [validLen, setValidLen] = useState(false);
    const [validNum, setValidNum] = useState(false);
    const [validUpper, setValidUpper] = useState(false);
    const [validLower, setValidLower] = useState(false);
    const [validSpecialCh, setValidSpecialCh] = useState(false);
    const [validConfirmPwd, setValidConfirmPwd] = useState(false);

    const [step, setStep] = useState(1);
    const [userId, setUserId] = useState(null);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [organization, setOrganization] = useState("");
    const [initialFirstName, setInitialFirstName] = useState("");
    const [initialLastName, setInitialLastName] = useState("");
    const [initialOrganization, setInitialOrganization] = useState("");
    const [errFirstName, setErrFirstName] = React.useState(null);
    const [errLastName, setErrLastName] = React.useState(null);
    const [errMsgNotEmpty, setErrMsgNotEmpty] = useState(null);

    const [errorSession, setErrorSession] = useState(false);

    useEffect(() => {
        if(Cookies.get('email')) {
            getUserData();
        }
    }, [])
    
    const getUserData = () => {
        try {
            axios({
            method: 'get',
            url: API_URL + API_PATH.getUserByEmail + `${Cookies.get('email')}`,
            })
            .then(async function (response) {
                if (response.status && response.status == '200') {
                    let fname = response.data.data.first_name;
                    let lname = response.data.data.last_name;
                    let org = response.data.data.organization;
                    setFirstName(fname);
                    setLastName(lname);
                    setOrganization(org);
                    setUserId(response.data.data.user_id);
                    setInitialFirstName(fname);
                    setInitialLastName(lname);
                    setInitialOrganization(org);
                } 
            })
            .catch(function (error) {
                
            })
        } catch (error) {
            console.error(error);
        }
    }

    const handleChange = name => event => {
        let val = event.target.value;
          if (name == 'first_name') {
            setFirstName(val);
            if(val === '') {
              setErrFirstName(true);
              setErrMsgNotEmpty('Cannot be empty');
            } else {
              setErrFirstName(false);
            }
          } else if (name == 'last_name') {
            setLastName(val);
            if(val === '') {
              setErrLastName(true);
              setErrMsgNotEmpty('Cannot be empty');
            } else {
              setErrLastName(false);
            }
          } else if (name == 'organization') {
            setOrganization(val);
          }
    }

    const updateUserData = () => {
        if(firstName !== initialFirstName || lastName !== initialLastName || organization !== initialOrganization) {
            let data = { "userId": userId, 'email':Cookies.get('email'), 'first_name': firstName, 'last_name': lastName, 'organization': organization }
            try {
              axios({
                method: 'post',
                data: data,
                url: API_URL + API_PATH.updateUserData,         
              })
                .then(async function (response) {
                  if (response.status && response.status == '200') {
                    setStep(2);
                  } else {
                    setErrMsgType('error')
                    setErrMsg('Something went wrong.');
                    setErrPopUp(true);
                  }
                })
            } catch (error) {
              console.error(error);
            }
        } else {
            setStep(2);
        }
    }

    //This code is use for update temporary password ... start
    const getUserLogin = async () => {
        try {
            axios({
                method: 'post',
                data: {
                    email: Cookies.get('email'),
                    pwd: passwordValues.pwd,
                    session: Cookies.get('session')
                },
                url: API_URL + API_PATH.updateTemporaryPasswordAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        await setCookie('idToken', response.data.message.data.AuthenticationResult.IdToken);
                        await setCookie('payload', response.data.message.payload);
                        await setCookie('atexpiry', response.data.message.data.AuthenticationResult.access_token_expiry);
                        await refreshToken();
                    }
                    else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        let msg = error.response.data && error.response.data.message.message ? error.response.data.message.message : "";
                        if(msg.indexOf("session") >= 0) {
                            setErrorSession(true);
                        } else {
                            setErrMsgType('error')
                            setErrMsg(error.response.data.message.message);
                            setErrPopUp(true)
                            setLoader(false);
                        }
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }
    //This code is use for update temporary password ... end

    //This code is use for get scrftoken ... start
    const refreshToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getcsrftoken,
            })
                .then(async function (response) {
                    if (response && response.data && response.data.csrfToken) {
                        axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken;
                        await getProfile(response.data.csrfToken);
                    } else {
                        if (Cookies.get('email')) {
                            clearCookie('email');
                            clearCookie('payload');
                            clearCookie('idToken');
                            clearCookie('atexpiry');
                        }
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                    setLoader(false);
                })
                .catch(function (error) {
                    if (Cookies.get('email')) {
                        clearCookie('email');
                        clearCookie('payload');
                        clearCookie('idToken');
                        clearCookie('atexpiry');
                    }
                    setErrMsgType('error')
                    setErrMsg('Something went wrong.');
                    setErrPopUp(true)
                    setLoader(false);
                })
        } catch (error) {
            if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
            }
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
        }
    }
    //This code is use for get scrftoken ... end

    //This code is use for get user information / get user profile ... start
    const getProfile = async (csrfToken) => {
        let details = await getUserDetails();
        try {
            axios({
                method: 'get',
                headers: {
                    'X-CSRF-Token': csrfToken
                },
                url: API_URL + API_PATH.getMyProfileAPI + `${details.user_id}`,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        await setCookie('firstName', response.data.data.first_name);
                        await setCookie('organization', response.data.data.organization);
                        await setCookie('lastName', response.data.data.last_name);
                        await clearCookie('session');
                        history.push({
                            pathname: '/UsersDashboard',
                            state: { newLogin: true }
                        });
                    } else {
                        if (Cookies.get('email')) {
                            clearCookie('email');
                            clearCookie('payload');
                            clearCookie('idToken');
                            clearCookie('organization');
                            clearCookie('atexpiry');
                        }
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                    setLoader(false);
                })
                .catch(function (error) {
                    if (error.response) {
                        if (error.response.data.message) {
                            setErrMsgType('error')
                            setErrMsg(error.response.data.message.message);
                            setErrPopUp(true)
                        } else {
                            setErrMsgType('error')
                            setErrMsg('Something went wrong.');
                            setErrPopUp(true)
                        }
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                    if (Cookies.get('email')) {
                        clearCookie('email');
                        clearCookie('payload');
                        clearCookie('idToken');
                        clearCookie('organization');
                        clearCookie('atexpiry');
                    }
                    setLoader(false);
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This code is use for get user information / get user profile ... end

    const ShowErrPopUP = () => {
        setErrPopUp(false)
    };

    const passwordHandleChange = name => event => {
        setErrNewPassword(false);
        setErrCnfPassword(false);
        setErrCode(false);
        setPasswordValues({ ...passwordValues, [name]: event.target.value });
        let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`])[A-Za-z\d\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]{8,}$/
        let val = event.target.value;
        if (name == 'pwd') {
            let tmp = val.length >= 8 ? true : false;
            setValidLen(tmp);
            setValidNum((/\d/).test(val));
            setValidUpper((/[A-Z]/).test(val));
            setValidLower((/[a-z]/).test(val));
            setValidSpecialCh((/[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]/).test(val));
    
            let vPwd = passwordCheck.test(val);
            setValidPwd(vPwd);
        } else if(name === 'confirmpwd') {
            if(passwordValues.pwd === val) {
                setValidConfirmPwd(true);
            } else {
                setValidConfirmPwd(false);
                setErrCnfPassword(true);
            }
        }
    }

    const handleClose = () => {
        history.push('/');
    }
    
    const handleCloseSessionBox = () => {
        setErrorSession(false);
    }

    return (
        <React.Fragment>
            {/* <Header /> */}
            <CssBaseline />
            <div className="signin-main">
                <Container maxWidth="md" className="user-form-container-first" style={step === 1 ? {width:'640px'} :{width:'544px'}}>
                    <Typography component="div">
                        <div className="form-logo">
                            <NavLink to="/" title='Close'><img className="close-icon" src={require('../../assets/icons/close.svg')} onClick={handleClose} /></NavLink>
                            <img src={require('../../assets/images/dataPointLogo.svg')} className="form-icon"></img>
                        </div>
                        {
                            step === 1 ?
                            <form className="root-form" noValidate autoComplete="off" style={step === 1 ? {width:'544px'} : {}}>
                                <h3 className="h3-title">Welcome {firstName} {lastName},</h3>
                                <Grid container className="root-box-step1">
                                    {errMsg ? <ErrorMessage message={errMsg} title="" visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> : null}
                                    <p>Verify Information</p>
                                    <p>Please verify that the information below is correct and edit as necessary</p>
                                    <Grid container spacing={1}>
                                        <Grid xs={6} item>
                                        <Paper className="paper" >
                                            <p className="text-input-label">First Name</p>
                                            <FilledInput 
                                            id="first_name" 
                                            className={errFirstName ? "form-text-input-error" : "form-text-input"} 
                                            type="text" variant="outlined" required 
                                            value={firstName} 
                                            onChange={handleChange('first_name')}
                                            data-testid='first_name'  
                                            endAdornment={ errFirstName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                            />
                                            {errFirstName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                        </Paper>
                                        </Grid>
                                        <Grid xs={6} item>
                                        <Paper className="paper" >
                                            <p className="text-input-label">Last Name</p>
                                            <FilledInput 
                                            id="last_name" 
                                            className={errLastName ? "form-text-input-error" : "form-text-input"} 
                                            type="text" variant="outlined" required 
                                            value={lastName} 
                                            onChange={handleChange('last_name')}
                                            data-testid='last_name'  
                                            endAdornment={ errLastName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                            />
                                            {errLastName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                        </Paper>
                                        </Grid>
                                        <Grid xs={6} item>
                                        <Paper className="paper" >
                                            <p className="text-input-label">Email</p>
                                            <FilledInput 
                                            id="email" 
                                            className="form-text-input"
                                            type="email" variant="outlined" 
                                            value={Cookies.get('email')}
                                            data-testid='email'  
                                            disabled={true}
                                            />
                                        </Paper>
                                        </Grid>
                                        <Grid xs={6} item style={{position: 'relative'}}>
                                            <Paper className="paper" >
                                                <p className="text-input-label">Organization</p>
                                                <FilledInput 
                                                id="organization" 
                                                className="form-text-input" 
                                                type="text" variant="outlined"
                                                value={organization}
                                                onChange={handleChange('organization')}
                                                data-testid='organization'  
                                                />
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} item>
                                        <Paper className="paper new-pwd-warning" >
                                            <div>
                                                <img src={require('../../assets/icons/warning-yellow.png')} />
                                            </div>
                                            <div>
                                                <p>New password</p>
                                                <p>Please continue to set a new password.</p>
                                            </div>
                                        </Paper>
                                    </Grid>
                                    <Grid xs={12} item>
                                        <Paper className="paper" style={{ textAlign: 'center', display: 'block' }} >
                                            <Button type="button" variant="outlined" id="update_My_btn" data-testid="update_pw_btn" 
                                            className="blue-btn" value="Save" 
                                            disabled={firstName==="" || lastName == "" } 
                                            onClick={updateUserData}>
                                                Save & continue</Button>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </form>
                            :
                            <form className="root-form" noValidate autoComplete="off">
                                <h3 className="h3-title">Update password</h3>
                                <Grid container className="root-box">
                                    <Grid item xs={12}>
                                        {errMsg ? <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> : null}
                                        <Grid container justify="center" spacing={spacing}>
                                            <Grid xs={12} item>
                                                <Paper className="paper" >
                                                    <p className="text-input-label">New password</p>
                                                    <FilledInput 
                                                        id="new_password" 
                                                        placeholder="" 
                                                        className={errPassword ? "form-text-input-error" : "form-text-input"} 
                                                        type="password" variant="outlined" required 
                                                        onChange={passwordHandleChange('pwd')} 
                                                        data-testid='new_password' 
                                                        endAdornment={ errPassword && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                                                    />
                                                </Paper>
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Paper className="paper" >
                                                    <p className="text-input-label">Confirm new password</p>
                                                    <FilledInput 
                                                        id="confirm_password" 
                                                        placeholder="" 
                                                        className={errCnfPassword ? "form-text-input-error" : "form-text-input"} 
                                                        type="password" variant="outlined" required 
                                                        onChange={passwordHandleChange('confirmpwd')} 
                                                        data-testid='confirm_password' 
                                                        endAdornment={ errCnfPassword && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                                                    />
                                                </Paper>
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Paper className="paper" >
                                                    <label className="gray-light-label">Password must contain the following:</label>
                                                    <ul className="signup-list">
                                                    <li className="gray-light-label"><FontAwesomeIcon icon={validLen ? faCheckCircle : faTimesCircle} className={validLen ? "successful-icon" : "error-icon"} /> At least 8 characters</li>
                                                    <li className="gray-light-label"><FontAwesomeIcon icon={validNum ? faCheckCircle : faTimesCircle} className={validNum ? "successful-icon" : "error-icon"} /> Include a number</li>
                                                    <li className="gray-light-label"><FontAwesomeIcon icon={validUpper ? faCheckCircle : faTimesCircle} className={validUpper ? "successful-icon" : "error-icon"} /> Include an upper case character</li>
                                                    <li className="gray-light-label"><FontAwesomeIcon icon={validLower ? faCheckCircle : faTimesCircle} className={validLower ? "successful-icon" : "error-icon"} /> Include a lower case character</li>
                                                    <li className="gray-light-label"><FontAwesomeIcon icon={validSpecialCh ? faCheckCircle : faTimesCircle} className={validSpecialCh ? "successful-icon" : "error-icon"} /> Include a special character</li>
                                                    </ul>
                                                </Paper>
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Paper className="paper" style={{ textAlign: 'center', display: 'block' }} >
                                                    <Button type="button" variant="outlined" id="update_My_btn" data-testid="update_pw_btn" 
                                                    className="blue-btn" value="Update password" 
                                                    disabled={validPwd && validConfirmPwd ? false : true } onClick={getUserLogin}>
                                                        Update password</Button>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        }
                    </Typography>
                </Container>
            </div>
            <Dialog
                open={errorSession}
                onClose={handleCloseSessionBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="session-popup"
            >
                <DialogContent>
                    <div className="error-container">
                        <img src={require('../../assets/icons/warning-delete-file.svg')} />
                        <div>
                            <label>Your session has expired</label>
                            <p>Please try again using your temporary password.</p>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button className="blue-btn font-14">
                        <NavLink to="/sign_in" style={{ textDecoration: 'none' }}  className={'txt-gray-500'}
                            >
                        Return to logon screen
                        </NavLink> 
                    </Button>   
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ChangeAdminPassword;
//End ChangeAdminPassword component code ....